import { Component, OnInit , Inject, ChangeDetectorRef} from '@angular/core';
import { map } from 'rxjs/operators';
import {FormBuilder , FormGroup , Validators} from '@angular/forms';
import {AddressService} from '../../services/address.service';
import {referralUser , Person} from '../../models/myreferrals.model'
import { ReferralService} from '../../services/referral.service'
import {MatDialogRef, MatDialog, MAT_DIALOG_DATA} from '@angular/material'

@Component({
  selector: 'app-add-referral',
  templateUrl: './add-referral.component.html',
  styleUrls: ['./add-referral.component.css']
})
export class AddReferralComponent implements OnInit {

  countryList =[]
  stateList =[]
  cityList =[]
  localityList = [];
  filterCountryList =[]
  filterStateList =[]
  filterCityList =[]
  referralLogin : FormGroup;
  button : string='';
  viewdata: any;
  customer:any;
  public persons: Person[];
  userDetail;
  

  constructor(
    private fb : FormBuilder,
    @Inject(MAT_DIALOG_DATA) public _data :any,
    public dialogRef :MatDialogRef<AddReferralComponent>,
    private chRef: ChangeDetectorRef,
    private myreferralService : ReferralService,
    private addressService : AddressService,

  ) { dialogRef.disableClose = true; }

  ngOnInit() {
    this.userDetail = JSON.parse(localStorage.getItem('userDetail'));
    this.getCountryList();
    this.createForm();
    this.getPersonType();
  }

  getCountryList() {
    this.addressService.getCountry()
      .pipe(map(res => {
        if (res) {
          this.countryList = res;
          this.filterCountryList = res;
        }
      }))
      .subscribe();
  }

  getStateList(countryId) {
    this.addressService.getState(countryId)
      .pipe(map(res => {
        if (res) {
          this.stateList = res;
          this.filterStateList = res;
        }
      }))
      .subscribe();
  }

  getCityList(stateId) {
    this.addressService.getCity(stateId)
      .pipe(map(res => {
        if (res) {
          this.cityList = res;
          this.filterCityList = res;
        }
      }))
      .subscribe();
  }
  getLocalityList(CityId) {
    this.addressService
      .getLocality(CityId)
      .pipe(
        map((res: any) => {
          if (res) {
            this.localityList = res;
            if (this.customer.LocalityId > 0) {
              const toSelect = this.localityList.find(
                (c) => c.LocalityId == this.customer.LocalityId
              );
              this.referralLogin
                .get("LocalityId")
                .setValue(toSelect.LocalityId);
            }
          }
        })
      )
      .subscribe();
  }
  createForm(){
    this.referralLogin = this.fb.group({
      IsCompany: ['', [Validators.required]],
      CompanyName: ['',[Validators.maxLength(40), Validators.pattern("^[a-z A-Z]*$")]],
      Tax: [''],
      ContactPerson: ['', [Validators.required,Validators.maxLength(40), Validators.pattern("^[a-z A-Z]*$")]],
      MobileNo: ['', [Validators.required, Validators.maxLength(18), Validators.minLength(10),Validators.pattern("^[0-9]*$")]],
      EmailId: ['', [Validators.required, Validators.email]],
      CountryId: [''],
      StateId: [''],
      CityId: [''],
      LocalityId: [''],
      Pincode: ['', [Validators.maxLength(18), Validators.minLength(5),Validators.pattern("^[0-9]*$")]],
      Address: [''],
    });
  }

  prePare()
  {
    const controls = this.referralLogin.controls;
    const _myReferral = new referralUser();
    _myReferral.ReferBy = this.userDetail.referralCode;
    _myReferral.isCompany = controls['IsCompany'].value;
    _myReferral.companyName = controls['CompanyName'].value;
    _myReferral.taxNumber = controls['Tax'].value;  
    _myReferral.UserName = controls['ContactPerson'].value;
    _myReferral.mobileNo = controls['MobileNo'].value;
    _myReferral.email = controls['EmailId'].value;
    _myReferral.address = controls['Address'].value;
    _myReferral.countryId = controls['CountryId'].value;
    _myReferral.cityId = controls['CityId'].value;
    _myReferral.pincode = controls['Pincode'].value;
     return _myReferral;
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onSubmit(){
    const controls = this.referralLogin.controls;
    /** check form */
    if (this.referralLogin.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    const addreferral = this.prePare();
    this.createReferralCustomer(addreferral)
   
  }



  // onqSubmit() {
  //   this.hasFormErrors = false;
  //   const controls = this.referralForm.controls;
  //   if (this.referralForm.invalid) {
  //     Object.keys(controls).forEach(controlName =>
  //       controls[controlName].markAsTouched()
  //     );
  //     this.hasFormErrors = true;
  //     return;
  //   }
  //   const addreferral = this.prepareReferral();
  //   if (this._data.Action == 'Add') {
  //     debugger;
  //     this.createreferral(addreferral);
  //   }
  //   else {
  //    this.onUpdate();
  //   }
  // }
  createReferralCustomer(_myReferral){
    this.myreferralService.addReferralCustomer(_myReferral).pipe(map(res => {
      if (res) {
        console.log(res)
        this.dialogRef.close({ _myReferral, isEdit: false });
      }

    }))
    .subscribe();
  }

  getPersonType(): void {
    this.persons = this.myreferralService.getMockArray();
    this.chRef.detectChanges();
  }


  filterValueCountry(searchCountry) {
    if (searchCountry != '') {
      this.filterCountryList = this.countryList.filter(option => { return option.Name.toLowerCase().startsWith(searchCountry.toLowerCase()) })
    }
    else {
      this.filterCountryList = this.countryList
    }
  }
}
